import { IReturnProductType } from '@ve/pages/hotel/types';

export default function (product: IReturnProductType | null): string {
    if (!product) return '';

    const { startDate, room } = product;
    const tourKey = `${startDate}__${room.category}`;
    return tourKey;
}